'use client';

import { Container, Alert, AlertTitle, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';

export function ErrorPlaceholder() {
  const t = useTranslations('Error');

  return (
    <Container>
      <Alert severity="warning" sx={{ my: '30vh' }} id="error">
        <AlertTitle>{t('component-failure')}</AlertTitle>
        <Typography>{t('troubleshooting-contact-support')}</Typography>
      </Alert>
    </Container>
  );
}
